import { render, staticRenderFns } from "./touchDrainageCard.vue?vue&type=template&id=79361252&scoped=true"
import script from "./touchDrainageCard.vue?vue&type=script&lang=js"
export * from "./touchDrainageCard.vue?vue&type=script&lang=js"
import style0 from "./touchDrainageCard.vue?vue&type=style&index=0&id=79361252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79361252",
  null
  
)

export default component.exports